import { defineStore } from "pinia";

export const useUsersStore = defineStore("users", {
  state: () => ({
    users: [],
    apiUrl: "https://yowl-community.cf-host.com/api/",
    token: "",
  }),
  actions: {
    //---------------------------action sur signup pour s'nscrire--------------------------------------
    registerUser(
      name,
      email,
      password,
      username,
      dateOfBirth,
      telephone,
      country,
      goTo
    ) {
      const requestOptions = {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          name: name,
          email: email,
          password: password,
          username: username,
          dateOfBirth: dateOfBirth,
          telephone: telephone,
          country: country,
          // confirme_password: this.confirme,
        }),
      };
      fetch(`${this.apiUrl}auth/register`, requestOptions)
        .then((response) => response.json())
        .then((end) => {
          (this.token = end.token),
            console.log("status"),
            console.log(end),
            (this.user = end.user);
          goTo.push("/signin");
        });
      // .catch((error) => console.log(error));
    },
    //---------------------------action sur signin pour se connecter--------------------------------------
    loginUser(email, password, goTo) {
      const requestOptions = {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,

          // confirme_password: this.confirme,
        }),
      };
      fetch(`${this.apiUrl}auth/login`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          (this.token = data.token), (this.user = data.user);
          if (data.user) {
            goTo.push("/suggested");
          } else {
            this.body = data.body;
          }
        });
      // .catch((error) => console.log(error));
      // .catch((error) => (this.message = error.message));
    },
  },
});
